export default __webpack_public_path__ + "c4ef75cd0727bb55b026d826504e19aa.png";